"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DryDesertsDeferredAction = void 0;
var AndOptions_1 = require("../inputs/AndOptions");
var SelectAmount_1 = require("../inputs/SelectAmount");
var DeferredAction_1 = require("./DeferredAction");
var DryDesertsDeferredAction = (function () {
    function DryDesertsDeferredAction(player, count, title) {
        if (count === void 0) { count = 1; }
        if (title === void 0) { title = 'Dry Deserts Global Event - Gain ' + count + ' resource(s) for influence'; }
        this.player = player;
        this.count = count;
        this.title = title;
        this.priority = DeferredAction_1.Priority.DEFAULT;
    }
    DryDesertsDeferredAction.prototype.execute = function () {
        var _this = this;
        var megacreditsAmount = 0;
        var steelAmount = 0;
        var titaniumAmount = 0;
        var plantsAmount = 0;
        var energyAmount = 0;
        var heatAmount = 0;
        var selectMegacredit = new SelectAmount_1.SelectAmount('Megacredits', 'Select', function (amount) {
            megacreditsAmount = amount;
            return undefined;
        }, 0, this.count);
        var selectSteel = new SelectAmount_1.SelectAmount('Steel', 'Select', function (amount) {
            steelAmount = amount;
            return undefined;
        }, 0, this.count);
        var selectTitanium = new SelectAmount_1.SelectAmount('Titanium', 'Select', function (amount) {
            titaniumAmount = amount;
            return undefined;
        }, 0, this.count);
        var selectPlants = new SelectAmount_1.SelectAmount('Plants', 'Select', function (amount) {
            plantsAmount = amount;
            return undefined;
        }, 0, this.count);
        var selectEnergy = new SelectAmount_1.SelectAmount('Energy', 'Select', function (amount) {
            energyAmount = amount;
            return undefined;
        }, 0, this.count);
        var selectHeat = new SelectAmount_1.SelectAmount('Heat', 'Select', function (amount) {
            heatAmount = amount;
            return undefined;
        }, 0, this.count);
        var selectResources = new AndOptions_1.AndOptions(function () {
            if (megacreditsAmount +
                steelAmount +
                titaniumAmount +
                plantsAmount +
                energyAmount +
                heatAmount !== _this.count) {
                throw new Error('Need to select ' + _this.count + ' resource(s)');
            }
            _this.player.megaCredits += megacreditsAmount;
            _this.player.steel += steelAmount;
            _this.player.titanium += titaniumAmount;
            _this.player.plants += plantsAmount;
            _this.player.energy += energyAmount;
            _this.player.heat += heatAmount;
            return undefined;
        }, selectMegacredit, selectSteel, selectTitanium, selectPlants, selectEnergy, selectHeat);
        selectResources.title = this.title;
        return selectResources;
    };
    return DryDesertsDeferredAction;
}());
exports.DryDesertsDeferredAction = DryDesertsDeferredAction;
//# sourceMappingURL=DryDesertsDeferredAction.js.map